export const TestStatusTitles = {
  pending: "0",
  approved: "1",
  rejected: "2",
};
